// FE-SCRM-057 — Proposal artifact client-side types.
//
// Mirrors backend/sales/proposals.py::serialize_proposal.

export type ProposalResponseStatus =
  | "awaiting"
  | "viewed"
  | "feedback_received"
  | "accepted"
  | "rejected";


export interface Proposal {
  proposal_id: string;
  opportunity_id: string;
  version: number;
  file_id: string;
  filename: string;
  content_type: string;
  size_bytes: number;
  sent_at: string | null;
  recipient_contact_id: string | null;
  response_status: ProposalResponseStatus | string;
  notes: string | null;
  created_at: string | null;
  updated_at: string | null;
  download_url?: string | null;
}


export interface ProposalListResponse {
  rows: Proposal[];
  total: number;
}


export interface MarkSentInput {
  recipient_contact_id: string;
  sent_at?: string;
}


export interface MarkResponseInput {
  response_status: ProposalResponseStatus;
  notes?: string | null;
}


export interface DownloadProposalResponse {
  download_url: string | null;
  filename: string;
  content_type: string;
}


export const PROPOSAL_RESPONSE_STATUSES: readonly ProposalResponseStatus[] = [
  "awaiting",
  "viewed",
  "feedback_received",
  "accepted",
  "rejected",
] as const;


export const RESPONSE_STATUS_LABEL: Record<ProposalResponseStatus, string> = {
  awaiting: "Awaiting",
  viewed: "Viewed",
  feedback_received: "Feedback received",
  accepted: "Accepted",
  rejected: "Rejected",
};
